import { render, staticRenderFns } from "./dd-checkbox.vue?vue&type=template&id=3f6f9ef5&scoped=true&"
import script from "./dd-checkbox.vue?vue&type=script&lang=ts&"
export * from "./dd-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./dd-checkbox.vue?vue&type=style&index=0&id=3f6f9ef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f9ef5",
  null
  
)

export default component.exports